export default "__VITE_ASSET__CFHDWAem__"